import React from 'react';
import { Navigate } from 'react-router-dom';
import { getUserId } from './Utils/Common';  // ✅ adjust path if needed

const ProtectedRoute = ({ children }) => {
  const userId = getUserId();  // check if userId exists in session

  if (!userId) {
    // ❌ No session found — redirect to login
    return <Navigate to="/" replace />;
  }

  // ✅ Logged in — allow access
  return children;
};

export default ProtectedRoute;
